import React from 'react';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import websiteLaptop from 'assets/images/registry/website_laptop.png';

import {
  RegistryWebsiteCrossSellWrapper,
  PhotoSection,
  TextSection,
  Text,
} from './RegistryWebsiteCrossSell.styles';

interface RegistryWebsiteCrossSellProps {
  url: string;
}

export const RegistryWebsiteCrossSell: React.FC<RegistryWebsiteCrossSellProps> = ({ url }) => {
  return (
    <RegistryWebsiteCrossSellWrapper>
      <PhotoSection url={websiteLaptop} />
      <TextSection>
        <Text>Let guests shop your registry directly on your website</Text>
        <ButtonV3 colorway="cove" component="a" href={url} size="small" target="_blank">
          Add registry to website
        </ButtonV3>
      </TextSection>
    </RegistryWebsiteCrossSellWrapper>
  );
};
